module.exports = __webpack_public_path__ + "static/media/banner_premier_league.2521d921.svg";